import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";

export default function UiAndUxDesign() {
  return (
    <div className="Ui-And-Ux-Design pt-[160px] sm:pt-0">
      <Helmet>
        <title>UI/UX Design - Mean3 Software Solutions</title>
        <meta
        name="description"
        content="Mean3 delivers intuitive UI/UX design that blends creativity with functionality. Enhance user satisfaction and boost your digital presence."
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
    </div>
  );
}

